import dynamic from 'next/dynamic'
import { ButtonHierarchy } from '@/components/styleguide/Button'
import { InternalLink } from '@/components/styleguide/Link'
import { Size } from '@/types/system'
import React from 'react'

import styles from './breadcrumbs.module.scss'
import { IconProps } from "@/components/styleguide/Icon"

const Icon = dynamic(() => import('@/components/styleguide/Icon'))

type Crumb = {
  label: string
  slug: string
  icon: IconProps['name']
}

export type BreadcrumbsProps = {
  crumbs: Crumb[]
  className?: string
}

export const Breadcrumbs = ({ crumbs, className = '' }: BreadcrumbsProps) => {
  return (
    <nav className={`${styles.main} ${className}`}>
      <ol className={styles.crumbs}>
        {crumbs.length > 1 &&
          crumbs.slice(0, crumbs.length - 1).map(crumb => {
            return (
              <li
                className={styles.crumb}
                key={crumb.slug}>
                <InternalLink
                  icon={crumb.icon}
                  href={crumb.slug}
                  hierarchy={ButtonHierarchy.Borderless}
                  size={Size.Small}>
                  {crumb.label}
                </InternalLink>
              </li>
            )
          })}
        <li
          className={`${styles.crumb} ${styles.current}`}
          aria-current="page">
          {crumbs[crumbs.length - 1].icon &&
            <Icon name={crumbs[crumbs.length - 1].icon} size={Size.Small} />}
          {crumbs[crumbs.length - 1].label}
        </li>
      </ol>
    </nav>
  )
}
